import axios from '@/utils/request';

// 获取师傅
export const getShituMaster = (data: any) => {
  return axios.request({
    url: 'Shitu/GetShituMaster',
    method: 'GET',
    params: data,
  });
};

// 获取徒弟详情
export const GetApprenticeDetails = (data: any) => {
  return axios.request({
    url: 'Shitu/GetApprenticeDetails',
    method: 'GET',
    params: data,
  });
};

// 获取意向师傅列表
export const getShituWillMasters = (data: any) => {
  return axios.request({
    url: 'Shitu/GetShituWillMasters',
    method: 'GET',
    params: data,
  });
};

// 获取师傅统计数据
export const getMasterStatistics = (data: any) => {
  return axios.request({
    url: 'Shitu/GetMasterStatistics',
    method: 'GET',
    params: data,
  });
};

// 获取徒弟统计数据
export const getApprenticeStatistics = (data: any) => {
  return axios.request({
    url: 'Shitu/GetApprenticeStatistics',
    method: 'GET',
    params: data,
  });
};

// 编辑师徒关系
export const editShituRelation = (data: any) => {
  return axios.request({
    url: 'Shitu/EditShituRelation',
    method: 'POST',
    data,
  });
};

// 获取师徒关系
export const getShituRelation = (data: any) => {
  return axios.request({
    url: 'Shitu/GetShituRelation',
    method: 'GET',
    params: data,
  });
};

// 获取师徒关系-列表
export const getShituRelations = (data: any) => {
  return axios.request({
    url: 'Shitu/GetShituRelations',
    method: 'GET',
    params: data,
  });
};

// 按照月份获取徒弟日志
export const getShituLogCalendar = (data: any) => {
  return axios.request({
    url: 'Shitu/GetShituLogCalendar',
    method: 'GET',
    params: data,
  });
};

// 获取徒弟日志
export const getShituLogs = (data: any) => {
  return axios.request({
    url: 'Shitu/GetShituLogs',
    method: 'GET',
    params: data,
  });
};

// 写日志
export const editShituLog = (data: any) => {
  return axios.request({
    url: 'Shitu/EditShituLog',
    method: 'POST',
    data,
  });
};

// 日志评价
export const editLogEvaluation = (data: any) => {
  return axios.request({
    url: 'Shitu/EditLogEvaluation',
    method: 'POST',
    data,
  });
};

// 获取日志详情
export const getLogDetails = (data: any) => {
  return axios.request({
    url: 'Shitu/GetLogDetails',
    method: 'GET',
    params: data,
  });
};

// 获取师徒沟通记录
export const getShituCommunications = (data: any) => {
  return axios.request({
    url: 'Shitu/GetShituCommunications',
    method: 'GET',
    params: data,
  });
};

// 编辑师徒沟通
export const editShituCommunication = (data: any) => {
  return axios.request({
    url: 'Shitu/EditShituCommunication',
    method: 'POST',
    data,
  });
};

// 获取师徒沟通详情
export const getCommunicationDetails = (data: any) => {
  return axios.request({
    url: 'Shitu/GetCommunicationDetails',
    method: 'GET',
    params: data,
  });
};

// 获取师徒任务
export const getShituTasks = (data: any) => {
  return axios.request({
    url: 'Shitu/GetShituTasks',
    method: 'GET',
    params: data,
  });
};

// 获取师徒任务详情
export const getTaskDetails = (data: any) => {
  return axios.request({
    url: 'Shitu/GetTaskDetails',
    method: 'GET',
    params: data,
  });
};

// 师傅：填报任务
export const masterEditShituTask = (data: any) => {
  return axios.request({
    url: 'Shitu/MasterEditShituTask',
    method: 'POST',
    data,
  });
};

// 徒弟：填报任务
export const apprenticeEditShituTask = (data: any) => {
  return axios.request({
    url: 'Shitu/ApprenticeEditShituTask',
    method: 'POST',
    data,
  });
};

// 任务审核
export const editTaskApproval = (data: any) => {
  return axios.request({
    url: 'Shitu/EditTaskApproval',
    method: 'POST',
    data,
  });
};

// 任务反馈
export const editFeedback = (data: any) => {
  return axios.request({
    url: 'Shitu/EditFeedback',
    method: 'POST',
    headers: { 'Content-Type': 'multipart/form-data' },
    data,
  });
};

// 任务反馈-评价
export const editFeedbackEvaluation = (data: any) => {
  return axios.request({
    url: 'Shitu/EditFeedbackEvaluation',
    method: 'POST',
    data,
  });
};

// 任务反馈审核
export const editFeedbackApproval = (data: any) => {
  return axios.request({
    url: 'Shitu/EditFeedbackApproval',
    method: 'POST',
    data,
  });
};
